/**
 * Central route metadata shared by App router and sidebar navigation.
 * Extend this list when adding new modules instead of editing App.tsx only.
 */
import { PermissionModuleKey, getModuleKeyForPath } from './permissionModules';

export interface AppRouteConfig {
  path: string;
  moduleKey?: PermissionModuleKey;
  label?: string;
}

export const APP_ROUTE_CONFIG: AppRouteConfig[] = [
  { path: '/dashboard', moduleKey: 'dashboard', label: 'Dashboard' },
  { path: '/ai-chat', moduleKey: 'dashboard', label: 'AI Chat' },
  { path: '/ai-prompts', moduleKey: 'configuration_settings', label: 'AI Prompts' },
  { path: '/ai-usage', moduleKey: 'configuration_settings', label: 'AI Usage' },
  { path: '/emails', moduleKey: 'emails', label: 'Emails' },
  { path: '/file-send', moduleKey: 'emails', label: 'Secure file link' },
  { path: '/clients', moduleKey: 'clients', label: 'Address Book' },
  { path: '/todos', moduleKey: 'todos', label: 'Todos' },
  { path: '/appointments', moduleKey: 'appointments', label: 'Appointments' },
  { path: '/admin/users', moduleKey: 'users', label: 'Users' },
  { path: '/activity-logs', moduleKey: 'activity_logs', label: 'Activity Logs' },
  { path: '/tools/database-browser', moduleKey: 'database_browser', label: 'Database Browser' },
  { path: '/forbidden' },
  { path: '/profile-settings' },
  { path: '/preferences' },
];

export function findRouteConfig(pathname: string): AppRouteConfig | undefined {
  const normalized = pathname.split('?')[0];
  return APP_ROUTE_CONFIG.find(
    (r) => normalized === r.path || normalized.startsWith(`${r.path}/`),
  );
}

export function resolveModuleKeyForPath(pathname: string): string | undefined {
  const route = findRouteConfig(pathname);
  if (route?.moduleKey) return route.moduleKey;
  return getModuleKeyForPath(pathname);
}
